import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="max-w-4xl mx-auto px-4 py-12 md:py-16 flex flex-col items-center text-center" data-id="element-104">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} data-id="element-105">
        <h2 className="font-handwritten text-4xl md:text-6xl text-forestGreen mb-6 leading-tight" data-id="element-106">
          "Mein Hund würgte jeden Morgen – <br className="hidden md:block" data-id="element-107" />
          bis wir endlich die Ursache fanden"
        </h2>
        <p className="font-serif text-xl md:text-2xl text-warmBrown mb-10 max-w-2xl mx-auto" data-id="element-108">
          Wie ich Milos ständige Übelkeit in den Griff bekam – ganz ohne
          Medikamente.
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="w-full max-w-3xl rounded-2xl overflow-hidden shadow-xl border-8 border-cardBg rotate-1" data-id="element-109">
        <img src="https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=1200&q=80" alt="Hund schaut nachdenklich" className="w-full h-auto object-cover aspect-[4/3] md:aspect-[16/9]" data-id="element-110" />
        <p className="font-handwritten text-lg text-warmBrown/70 mt-3 text-center" data-id="element-111">
          Milo an einem seiner besseren Tage 🐾
        </p>
      </motion.div>
    </section>;
}